import { useEffect, useState } from 'react';

/**
 * Relógio reativo: retorna Date.now() atualizado a cada `intervalMs`.
 * Uso: tempos decorridos ("⏱ 3m 42s") que precisam CRESCER na tela sem
 * depender de evento realtime. Default 1s (admin 2026-06-11: "real-time é em
 * tempo real" — o contador correndo a cada segundo é o sinal visível de que a
 * demanda está viva). Re-render é local ao componente que usa o hook.
 */
export function useNowTick(intervalMs = 1_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
